import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {AppSettingsService} from "../app-settings/app-settings.service";

const INDIA_COUNTRY_NAME = "India";
const INDIA_COUNTRY_ID = "IN";
export const BILL_FROM_STRUCTURE_TYPE = Object.freeze({
  CENTRALIZED: "CENTRALIZED",
  DECENTRALIZED: "DECENTRALIZED",
});

@Injectable()
export class BillFromService {
  private url: string = "/api/bill-from";

  constructor(
    public http: HttpClient,
    public appSettings: AppSettingsService,
  ) {}

  /* ===== Logic related methods ===== */

  async showBillFrom(project) {
    const enabledBillFrom = await this.appSettings.getFeaturePermission("enableBillFrom");
    return enabledBillFrom &&
      this.isregionIndia(project);
  }

  isregionIndia(project: any) {
    return project.country.countryName === INDIA_COUNTRY_NAME ||
      project.countryId === INDIA_COUNTRY_ID || // graphql
      project.country.countryId === INDIA_COUNTRY_ID; // sequelize
  }

  isCentralized(project: any) {
    return project.billFromStructure === BILL_FROM_STRUCTURE_TYPE.CENTRALIZED;
  }

  isDecentralized(project: any) {
    return project.billFromStructure === BILL_FROM_STRUCTURE_TYPE.DECENTRALIZED;
  }

  async getBillFromBuildings(projectId, projectCountry, type = "HPBillFrom") {
    return this.getITSMBillFromAccounts(type, projectId, projectCountry);
  }

  /*  ==== URL ENDPOINTS ==== */
  getITSMBillFromAccounts(type, id, country): Promise<any> {
    return this.http.get(`${this.url}/itsm-bill-from-accounts?type=${type}&id=${id}&country=${country}`)
      .toPromise();
  }
}
